// extracted by mini-css-extract-plugin
export var createdDate = "_kd-1";
export var divider = "_kd-2";
export var headerDivider = "_kd-3";
export var messagesCard = "_kd-0";
export var messagesContainer = "_kd-7";
export var messagesContainerWrapper = "_kd-4";
export var pointerCapturingButtonBoxes = "_kd-a";
export var showLeftPanelButton = "_kd-9";
export var showMoreButton = "_kd-c";
export var showMoreButtonContainer = "_kd-b";
export var summaryTitle = "_kd-6";
export var systemMessageCardWrapper = "_kd-d";
export var topButtons = "_kd-8";
export var withPadding = "_kd-5";